import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";

const AppointmentCardSkeleton = ({ id }: { id: string }) => {
    return (
        <>
            <div
                key={id}
                className="bg-white dark:bg-neutral-800 p-6 w-full margin-top-25 full-schedule animate-pulse"
            >
                <div className="flex padding-top-10 justify-between items-center mb-4">
                    <div className="flex items-center space-x-2 w-9/12">
                        <span className={`text-size-18 font-semibold text-color-map-marker-asset flex items-center ${isMobile() ? "w-full" : "w-3/12"} truncate`}>
                            <div className="w-3/4 h-8 bg-gray-300 dark:bg-neutral-700 rounded" />
                        </span>
                        {!isMobile() ? <div className="flex gap-6 schedule-tags w-9/12 media_leftRow">
                            <div className="w-1/6 h-16 bg-gray-300 dark:bg-neutral-700 rounded" />
                            <div className="w-1/6 h-16 bg-gray-300 dark:bg-neutral-700 rounded" />
                            <div className="w-1/6 h-16 bg-gray-300 dark:bg-neutral-700 rounded" />
                        </div> : null}
                    </div>
                    <div className="w-3/12 flex items-center gap-6 justify-end">
                        <div className="w-2/4 h-8 bg-gray-300 dark:bg-neutral-700 rounded" />
                    </div>
                </div>

                <hr className="border-gray-200 dark:border-neutral-700 my-2" />

                <div className="flex items-start justify-between mb-4 padding-top-25">
                    {!isMobile() ? <div className="flex space-x-2 w-9/12">
                        <div className="w-1/4 h-16 bg-gray-300 dark:bg-neutral-700 rounded margin-right-10" />
                        <div className="w-1/6 h-16 bg-gray-300 dark:bg-neutral-700 rounded" />
                    </div> : null}
                    <div className={`${isMobile() ? "!w-full" : "w-3/12"} flex items-center justify-end`}>
                        <div className="flex gap-6 items-center">
                            <div className="w-16 h-16 rounded-full bg-gray-300 dark:bg-neutral-700" />
                            <div className="flex flex-col">
                                <div className="width-100 h-8 bg-gray-300 dark:bg-neutral-700 rounded margin-bottom-10" />
                                <div className="width-200 h-8 bg-gray-300 dark:bg-neutral-700 rounded" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="display-flex gap-20 margin-top-25 margin-bottom-15">
                    <div className={`${isMobile() ? "w-full" : "w-1/6"} h-16 bg-gray-300 dark:bg-neutral-700 rounded`} />
                </div>
            </div>
        </>
    );
}

export default AppointmentCardSkeleton;